// Ш2/Ш3 — забележката към изчертан ред.
//
// Едно определение за „има ли забележка", защото от него зависи цветът на
// иконата на реда и дали колоната в справките е празна. Огледало е на
// server/services/drawings.py::has_note — празен низ, само интервали и липсваща
// стойност значат едно и също. Ако двете страни се разминат, иконата ще свети
// черна за ред, който в справката излиза празен.
export const hasNote = (note) => String(note ?? '').trim().length > 0;

export const cleanNote = (note) => String(note ?? '').trim();
